import React from 'react';

import utils     from '../../utils';
import Cookies   from 'js-cookie';
import constants from '../../values/constants';

import {
  Route      ,
  Routes     ,
  Navigate   ,
  useNavigate,
} from 'react-router-dom';

import { SubTabs        } from '../../components';
import { ITopMenuItem   } from '../../types/common.interface';
import { useTranslation } from 'react-i18next';
import {
  ADMIN_FINANCIAL_TABS,
  FINANCIAL_SUB_TABS,
  FINANCIAL_SUB_TABS_ADMIN,
  FINANCIAL_SUB_TABS_COMPANY,
} from '../../values/subTabs';

import NotFound                        from '../NotFound';
import DebtsContainer                  from './screens/DebtsScreen/Container';
import OnlineTransaction               from './screens/OnlineTransaction';
import PayToDriverContainer            from './screens/PayToDriverScreen/Container';
import DebtToDriverContainer           from './screens/DebtToDriverScreen/Container';
import WithdrawalScreenScreens         from './screens/WithdrawalScreen';
import FinancialGroupContainer         from './screens/FinancialGroupScreen/Container';
import CompanyFactorsContainer         from './screens/CompanyFactors/Container';
import FindTransactionContainer        from './screens/FindTransactionScreen/Container';
import ApproveParentTransaction        from './screens/ApproveParentTransaction';
import ParentTransactionContainer      from './screens/ParentTransaction/Container';
import DriverTransactionContainer      from './screens/DriverTransaction/Container';
import PaymentOnline2CompanyContainer  from './screens/PaymentOnline2Company/Container';
import FactorsNeedPay2CompanyContainer from './screens/FactorsNeedPay2Company/Container';
import CompanyFinancialReportContainer from './screens/financialReportCompany/Container';

import './index.scss';

const FinanCialScreen: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const navigate = useNavigate();
  const userType = utils.stringHexConversion.reverse(Cookies.get(constants.USER.TYPE));
  const currentMenu = window.location.pathname.split("/")[4];

  const { t } = useTranslation();

  let financialTabs =
    userType === "ADMIN"
      ? FINANCIAL_SUB_TABS_ADMIN
      : userType === "COMPANY"
        ? FINANCIAL_SUB_TABS_COMPANY
        : FINANCIAL_SUB_TABS;
  let adminFinancialTab = ADMIN_FINANCIAL_TABS

  financialTabs     = financialTabs.map((item)     => ({...item, value: t(item.value)}));
  // adminFinancialTab = adminFinancialTab.map((item) => ({...item, value: t(item.value)}));

  const [selectedTab, setSelectedTab] = React.useState<ITopMenuItem>(financialTabs.find(
    (item) => item.pathname === currentMenu
  ) as ITopMenuItem);

  const [selectedAdminTab, setSelectedAdminTab] = React.useState<ITopMenuItem>(adminFinancialTab.find(
    (item) => item.pathname === currentMenu
  ) as ITopMenuItem);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onTabClick(tab: any) {
    navigate(tab.pathname);
    setSelectedTab(tab);
    setSelectedAdminTab(tab);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------ Start UseEffect functions --------------------------------------------

  React.useEffect(() => {
    setSelectedTab(financialTabs.find((item) => item.pathname === currentMenu) as ITopMenuItem);
  }, [currentMenu]);

  // ! ------------------------------------------- End UseEffect functions ---------------------------------------------
  // ! =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="setting-screen">
      <SubTabs tabs={financialTabs} onClick={onTabClick} selected={selectedTab as ITopMenuItem} />
      {userType === 'ADMIN' && (
        <SubTabs tabs={adminFinancialTab} onClick={onTabClick} selected={selectedAdminTab as ITopMenuItem} />
      )}
      <Routes>
        <Route path='/'                             element={<Navigate to={'transaction'} />} />
        <Route path='/debts'                        element={<DebtsContainer              />} />
        <Route path='/withdrawal/*'                 element={<WithdrawalScreenScreens     />} />
        <Route path='/transaction'                  element={<FindTransactionContainer    />} />
        <Route path='/debt-to-driver'               element={<DebtToDriverContainer       />} />
        <Route path='/company-factor'               element={<CompanyFactorsContainer     />} />
        <Route path='/approve-parent-transaction/*' element={<ApproveParentTransaction    />} />
        {userType === 'ADMIN' && (
          <>
            <Route path='/pay-to-driver'              element={<PayToDriverContainer           />} />
            <Route path='/financial-group'            element={<FinancialGroupContainer        />} />
            <Route path='/parent-transaction'         element={<ParentTransactionContainer     />} />
            <Route path='/driver-transaction'         element={<DriverTransactionContainer     />} />
            <Route path='/online-transaction/*'       element={<OnlineTransaction              />} />
            <Route path='/paymeht-online-2-company/*' element={<PaymentOnline2CompanyContainer />} />
          </>
        )}
        {userType === 'COMPANY' && (
          <>
            <Route path='/factor-company'           element={<FactorsNeedPay2CompanyContainer />} />
            <Route path='/financial-report-company' element={<CompanyFinancialReportContainer />} />
          </>
        )}
        <Route path='/*' element={<NotFound />} />
      </Routes>
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default FinanCialScreen;
